/**
 * 获取指定日期的格式化字符串
 * @param date
 * @returns {string}
 */
export function formatDate(date) {
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的
    const day = date.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
}

/**
 * 获取指定时间距离当前的时间间隔
 * @param date
 * @returns {string}
 */
export function timeAgo(date) {
    const now = new Date();
    const diff = now - date; // 差值，单位为毫秒
    const minutes = Math.floor(diff / 60000); // 将毫秒转换为分钟
    const hours = Math.floor(diff / 3600000); // 将毫秒转换为小时
    const days = Math.floor(diff / 86400000); // 将毫秒转换为天

    if (minutes < 60) {
        return `${minutes}分钟前`;
    } else if (hours < 24) {
        return `${hours}小时前`;
    } else {
        return `${days}天前`;
    }
}
